import { AuthRoles } from "configs/roles";
import { DocumentationUICard } from "./DocumentationUICard";
import { DocumentationUIProvider } from "./DocumentationUIContext";
import { CreateDocumentation } from "./pages/CreateDocumentation";
import { EditDocumentation } from "./pages/EditDocumentation";

export const DocumentationRoutes = [
  {
    path: "/documentation",
    element: (
      <DocumentationUIProvider>
        <DocumentationUICard />
      </DocumentationUIProvider>
    ),
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/documentation/create",
    element: <CreateDocumentation />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/documentation/:id/edit",
    element: <EditDocumentation />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
];
